import { LogLevel } from '@lib/shared-interface-utility-types';

export class CodedError extends Error {
    public override name = CodedError.name;
    public code: string;

    /*
        When this class is extended to create a custom exception,
        this property can be overridden to 
        suppress alerts for the error when they occur.
        In production, only errors with a level of 'error' will trigger alerts.

        When possible, it is preferable to only throw exceptions
        when something truly unexpected has occurred.
        We should try to prevent "expected errors" whenever possible,
        and instead handle such situations without throwing an exception.
        How best to handle such situations will depend on the context
    */
    public level: LogLevel = LogLevel.error;

    public data: unknown;

    public constructor(message: string, code?: string, data?: unknown) {
        super(message);
        this.code = code ?? 'CODED_ERROR';
        this.data = data;
    }
}
